import messages from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision/messages';
import { PROCEDURE_STATUSES } from 'containers/data-structure';

export const MODE = {
  BLESSE: 'Blessé',
  DECEASED: 'Deceased',
};

export const DECISION = {
  DECISION: 'decision',
  CONTEST_REASON: 'contestReason',
  REJECTION_REASON: 'rejectionReason',
  DOCUMENT: 'document',
} as const;

export const EMPTY_DECISION = {
  [DECISION.DECISION]: '',
  [DECISION.CONTEST_REASON]: '',
  [DECISION.REJECTION_REASON]: '',
  [DECISION.DOCUMENT]: {},
};

export const DECISION_STATUS = {
  [messages.confirm.id]: {
    status: PROCEDURE_STATUSES.VALIDATED,
    disabled: true,
  },
  [messages.dismiss.id]: {
    status: PROCEDURE_STATUSES.REJECTED,
    disabled: false,
  },
  [messages.contest.id]: {
    status: PROCEDURE_STATUSES.CONTESTED,
    disabled: true,
  },
};
